import { VueConstructor } from "vue"
import Bars from "vuebars"

export default ({ Vue }: { Vue: VueConstructor }) => {
  Vue.use(Bars)
}
